import React from 'react';
import PropTypes from 'prop-types';

export const Avatar = ({ src, alt, size = 40 }) => {
  return (
    <img
      src={src}
      alt={alt}
      className="rounded-full object-cover border border-white/10"
      style={{ width: size, height: size }}
    />
  );
};

Avatar.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  size: PropTypes.number,
};